import Lottie from "lottie-react";
import React, { useEffect } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { useQueryClient } from "react-query";
import { useNavigate, useLocation } from "react-router-dom";
import ThankyouAnimation from "./thank-you-animation.json";
import SubscriptionArrowGif from "../../assets/subscription-arrow.gif";
import HelpCard from "./HelpCard";
import { ThankYouLocationState } from "./types";
import { useDetectDevice } from "../../hooks/use-detect-device";
import AppleAppStoreLink from "../enrollment-modal/completed-message/apple-app-store-link";
import GooglePlayStoreLink from "../enrollment-modal/completed-message/google-play-store-link";

// function maskEmail(email: string): string {
//     const [local, domain] = email.split('@');
//     if (!local || !domain) return email;
//     if (local.length <= 6) {
//         return `${local[0]}${"*".repeat(Math.max(0, local.length - 2))}${local.slice(-1)}@${domain}`;
//     }
//     return `${local.slice(0, 3)}${"*".repeat(local.length - 6)}${local.slice(-3)}@${domain}`;
// }

export function ThankYou(props: Partial<ThankYouLocationState> = {}) {
    const navigate = useNavigate();
    const location = useLocation();
    const queryClient = useQueryClient();
    const device = useDetectDevice();
    const state = location.state as ThankYouLocationState | null;

    const email = props.email ?? state?.email ?? "";
    const planName = props.planName ?? state?.planName ?? "";
    const fromMobile = props.fromMobile ?? state?.fromMobile ?? false;

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            void queryClient.refetchQueries(["profile"]);
        }
    }, [queryClient]);

    useEffect(() => {
        if (fromMobile) {
            const timeout = setTimeout(() => {
                if (device.isAndroid()) {
                    window.location.href =
                        "intent://payment#Intent;scheme=habitnu;package=com.habitnu;end";
                } else if (device.isIos()) {
                    window.location.href = "habitnu://payment";
                }
            }, 3000);
            return () => {
                clearTimeout(timeout);
            };
        }
        // Explicit return for the effect
        return undefined;
    }, [fromMobile, device]);

    const handleGoToLogin = () => {
        navigate("/login");
    };

    // const handleReturnToApp = () => {
    //     if (device.isAndroid()) {
    //         window.location.href =
    //             "intent://payment#Intent;scheme=habitnu;package=com.habitnu;end";
    //     } else if (device.isIos()) {
    //         window.location.href = "habitnu://payment";
    //     }
    // };

    let messageNode: React.ReactNode;
    if (email) {
        messageNode = (
            <>
                <b>Your Health Transformation Starts Now.</b>
                <br />
                <br /> A password reset link will be sent shortly to your email:
                <br />
                <b>{email}</b>
                <br />
                (Please check your inbox or spam folder.)
            </>
        );
    } else {
        messageNode = (
            <>
                Something went wrong while sending the reset password on the
                email right now. Please contact support at{" "}
                <b>support@habitnu.in</b>
            </>
        );
    }
    return (
        <div className="thankyou-bg">
            <div className="thankyou-card text-center">
                <div className="thankyou-success-icon">
                    <Lottie
                        animationData={ThankyouAnimation}
                        autoPlay
                        loop
                        className="thankyou-lottie"
                    />
                </div>

                <h3 className="thank-you-title">Thank you for subscribing!</h3>
                <p className="thank-you-subtitle">
                    {planName && (
                        <>
                            <b style={{ color: "#707EFF" }}>
                                You&rsquo;re all set for {planName}
                            </b>
                            .
                        </>
                    )}
                </p>
                <p className="secondary-subtitle">{messageNode}</p>

                {fromMobile ? (
                    <>
                        <div
                            style={{
                                margin: "24px 0 8px 0",
                                fontWeight: 500,
                                fontSize: 16,
                                color: "#1841bdff",
                            }}
                        >
                            Purchase is successful. Please return to the HabitNu
                            app to start thriving.
                        </div>
                        {/* <Button
                            variant="primary"
                            size="lg"
                            className="start-subscription-btn"
                            style={{ marginTop: 12 }}
                            onClick={handleReturnToApp}
                        >
                            Return to App
                        </Button> */}
                    </>
                ) : (
                    <Button
                        variant="primary"
                        size="lg"
                        className="start-subscription-btn"
                        onClick={handleGoToLogin}
                    >
                        Go to Login{" "}
                        <img
                            src={SubscriptionArrowGif}
                            alt="Go to Login"
                            className="subscription-arrow-gif"
                        />
                    </Button>
                )}

                <div className="thankyou-app-download-section">
                    <span className="thankyou-app-download-title">
                        Visit our mobile app:
                    </span>
                    <Row className="thankyou-app-row align-items-center justify-content-center">
                        <Col xs="auto" className="p-0">
                            <AppleAppStoreLink />
                        </Col>
                        <Col xs="auto" className="p-0">
                            <GooglePlayStoreLink />
                        </Col>
                    </Row>
                </div>
            </div>
            <HelpCard />
        </div>
    );
}
